module.exports = __webpack_public_path__ + "assets/img/img-map-kumamoto-sp.b588a246.svg";